import { Link } from "react-router-dom";
import { categoryEntries } from "@/mocks/movies";

export default function CategoryQuick() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            <Link to="/category">影视分类</Link>
          </h2>
          <p className="mt-2 text-sm text-foreground-600">按题材与类型快速进入你想看的内容分区</p>
        </div>
        <Link
          to="/category"
          className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 md:inline-flex"
        >
          全部分类
          <i className="ri-arrow-right-line leading-none"></i>
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
        {categoryEntries.map((entry) => (
          <Link
            key={entry.key}
            to={entry.href}
            className="group flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-accent-400 hover:bg-accent-50"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600 transition-colors group-hover:bg-accent-500 group-hover:text-primary-950">
              <i className={`${entry.icon} text-xl leading-none`}></i>
            </span>
            <span className="min-w-0">
              <span className="block truncate text-sm font-bold text-foreground-950">{entry.name}</span>
              <span className="mt-0.5 block truncate text-xs text-foreground-500">{entry.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}